export function categoryMatchesSlug(category, urlSlug) {
  if (!category || !urlSlug) {
    return false;
  }
  if (category.slug === urlSlug) {
    return true;
  }
  const { slugs } = category;
  if (!slugs) {
    return false;
  }
  return Object.values(slugs).includes(urlSlug);
}

export function findCategoryByUrlSlug(categories, urlSlug) {
  return categories?.find(category => categoryMatchesSlug(category, urlSlug));
}
